import { NgModule } from "@angular/core";
import { CurrencySymbolPipe } from "../invoices/currency-symbol.pipe";
import { NgbdSortableHeader } from "../sortable.directive";

@NgModule({
    imports: [
       
    ],
    declarations: [
        CurrencySymbolPipe,
        NgbdSortableHeader
    ],
    exports: [
        CurrencySymbolPipe,
        NgbdSortableHeader
    ],
    bootstrap: []
  })
export class GlobalModule { }